/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Community_Sponsor_CtaInputs */



/**
* | output |
* | --- |
* | "To get your VEKN ID, contact one of the officials below and ask them to sponsor you." |
*
* @param {Community_Sponsor_CtaInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const community_sponsor_cta = /** @type {((inputs?: Community_Sponsor_CtaInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Community_Sponsor_CtaInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Pour obtenir votre VEKN ID, contactez l'un des officiels ci-dessous et demandez-lui de vous parrainer.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Para obtener tu ID VEKN, contacta con uno de los oficiales de abajo y pídele que te patrocine.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Para obter seu ID VEKN, entre em contato com um dos oficiais abaixo e peça a ele para te patrocinar.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Per ottenere il tuo VEKN ID, contatta uno degli ufficiali qui sotto e chiedigli di sponsorizzarti.")
	return /** @type {LocalizedString} */ ("To get your VEKN ID, contact one of the officials below and ask them to sponsor you.")
});